import { useState, useEffect } from "react";

const OrderLocationPop = ({ order, toggleLocationPop }) => {
  const [mapUrl, setMapUrl] = useState("");
  const [copyDone, setCopyDone] = useState(false);

  useEffect(() => {
    const location = order.location.split(",");
    setMapUrl(`https://www.google.com/maps/search/?api=1&query=${location[0]},${location[1]}`);
  }, [order]);

  const handleCopyClick = () => {
    // Open the map URL in a new tab or window
    // Create a temporary input element to copy text to clipboard
    const tempInput = document.createElement("input");
    tempInput.value = mapUrl;
    document.body.appendChild(tempInput);
    tempInput.select();
    try {
      document.execCommand("copy");
      // Optionally, you can provide user feedback that the text has been copied
    } catch (err) {
      console.error("Unable to copy text: ", err);
    } finally {
      document.body.removeChild(tempInput);
    }

    setCopyDone(true);
  };

  // for open location button
  const handleOpenLocation = () => {
    window.open(mapUrl, "_blank");
  };

  return (
    <>
      <div className="fixed w-[45%] top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 bg-white p-6 shadow-lg rounded-lg  border">
        <button
          className="absolute top-2 right-2 text-gray-600 hover:text-gray-800"
          onClick={() => toggleLocationPop(order.orderId)}
        >
          <svg
            className="w-6 h-6"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              d="M6 18L18 6M6 6l12 12"
            ></path>
          </svg>
        </button>
        <div className="my-2">
          <h2 className="text-xl mb-4">
            الموقع الجغرافي للطلب رقم
            <span className="underline text-blue-500 mx-4">{order.orderId}</span>
          </h2>

          <div className="flex flex-col items-end my-2">
            <div className="mb-2 w-full text-right">
              <input
                type="text"
                value={mapUrl}
                className="w-full py-2 px-4 border text-gray-800 font-semibold text-lg"
                dir="rtl"
                disabled
              />
            </div>
            {copyDone ? (
              <p className="w-full font-bold text-lg text-green-500 mb-2 flex items-center justify-center">
                تم نسخ العنوان الجغرافي بنجاح
              </p>
            ) : (
              ""
            )}
            <div className="mt-2 w-full flex flex-row-reverse gap-4 items-center justify-center">
              <button
                type="button"
                className="bg-blue-500 text-white px-4 py-2 rounded-lg"
                onClick={handleCopyClick}
              >
                نسخ العنوان
              </button>

              <button
                type="button"
                className="bg-blue-500 text-white px-4 py-2 rounded-lg"
                onClick={handleOpenLocation}
              >
                قتح الموقع الجغرافي
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default OrderLocationPop;
